/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum SystemMainSettings {
  CreatePr53UserSmsText = 13,
  CrmDepartmentId = 14,
  CrmMaxTicketCountPerUser = 15,
  DollarPriceToRial = 16,
  MaximumCreateSmartSmsRequestWithoutSendPerDay = 17,
  MinimumPercentOfSendSmartSmsRequestUntilFixedFloorNumber = 18,
  FixedFloorNumberOfSendSmartSmsRequest = 19,
  MinimumNumberOfSmartClubNumberForCreateRequest = 20,
  Tax = 100,
  UserExpireSmsText = 102,
  ResolutionOfParliament = 110,
  ConfirmationSmsText = 123,
  NotReceivedByPhoneBlackListDaysCount = 124,
  MinimumOnlineAmount = 125,
  CreateSmartSmsRequestSmsText = 126,
  DefaultPanelPrivateNumber = 127,
  CreateTokenSmsText = 128
}
